module.exports = __webpack_public_path__ + "static/media/tag.8e63e41f.svg";